export const pageViewRecordFunctionCacheKeys = {
  middleware: Symbol('middleware'),
  facetChange: Symbol('facetChange')
}
